// Domain-based configuration utility
// Detects current domain and returns appropriate settings

export interface DomainConfig {
  language: 'ko' | 'en'
  apiBaseUrl: string
  domain: string
}

/**
 * Get configuration based on current domain
 * - freeple.me → Korean version
 * - freeple.my → English version
 */
export const getDomainConfig = (): DomainConfig => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  
  // Check if it's the .my domain (English)
  if (hostname.endsWith('.my') || hostname === 'freeple.my') {
    return {
      language: 'en',
      apiBaseUrl: `https://${hostname}`,
      domain: hostname
    }
  }
  
  // Default: .me domain or localhost (Korean)
  // For localhost, use the env variable or default
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return {
      language: 'ko',
      apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
      domain: hostname
    }
  }
  
  // Production .me domain
  return {
    language: 'ko',
    apiBaseUrl: `https://${hostname}`,
    domain: hostname
  }
}

// Export a singleton config for use throughout the app
export const domainConfig = getDomainConfig()
